export const classNames = (cls: string[]) => cls.join(' ');
